/* eslint-disable default-case */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unsafe-argument, max-params */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* eslint-disable complexity, @typescript-eslint/no-unsafe-call */
/* eslint-disable no-unused-vars, @typescript-eslint/no-unsafe-member-access  */
/* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment  */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.

import { kfrm, css } from '@elliemae/ds-system';
import type { FlattenSimpleInterpolation } from '@elliemae/ds-system';
import type { MobileBannerTypesT } from '../index.d';
import { MOBILE_BANNER_TYPES } from './bannerTypes.js';

export const slideIn = kfrm`
  0% {
    transform: translate3d(0, -100%, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
`;

export const slideOut = kfrm`
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;

export const spanContainer = (height: number) => kfrm`
  0% {
    height: 0px;
  }
  100% {
    height: ${height}px;
  }
`;

export const shrinkContainer = (height: number) => kfrm`
  0% {
    height: ${height}px;
  }
  100% {
    height: 0px;
  }
`;

export const handleBorderColor = (type: MobileBannerTypesT, { colors }): string => {
  switch (type) {
    case MOBILE_BANNER_TYPES.SUCCESS:
      return colors.success[900];
    case MOBILE_BANNER_TYPES.INFO:
      return colors.brand[600];
    case MOBILE_BANNER_TYPES.WARNING:
      return colors.warning[900];
    case MOBILE_BANNER_TYPES.ERROR:
      return colors.danger[900];
    default:
      return '';
  }
};

export const handleAnimation = (
  isAnimating: boolean,
  isOpen: boolean,
  height: number | null = null,
): FlattenSimpleInterpolation => {
  if (isAnimating) {
    if (isOpen) {
      return css`
        animation: ${height ? spanContainer(height) : slideIn} 0.5s ease-in;
      `;
    }
    return css`
      animation: ${height ? shrinkContainer(height) : slideOut} 0.5s ease-in;
    `;
  }
  return '';
};
